module.exports = __webpack_public_path__ + "img/choose.c031d7f4.jpg";